import { Component } from '@angular/core';
import { ProductListItemComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-list-item',
  templateUrl: './product-list-item.component.html',
  styleUrl: './product-list-item.component.scss',
  standalone: false,
})
export class CustomProductListItemComponent extends ProductListItemComponent {}
